import { LocalizedText } from "@/shared/types/type/search"

type LocaleKey = keyof LocalizedText

export const pickLocalizedText = (value: LocalizedText, locale: string) => {
  const key = (locale === "ko" || locale === "en" || locale === "jp" || locale === "cn" ? locale : "ko") as LocaleKey
  return value[key] || value.ko
}
